import type { NumberedDifference } from 'zstore/differenceListStore';

export interface GroupLabelFromStore {
  /** The member number shown on the focused difference box, e.g. "1.3". */
  labelText: string;
  /** Position of the focused member within its group (0-based). */
  index: number;
  /** Previous member for the popup's left chevron (wraps around). */
  previous: NumberedDifference;
  /** Next member for the popup's right chevron (wraps around). */
  next: NumberedDifference;
  /** The group's reading-order representative (members[0]); decides the popup side. */
  representative: NumberedDifference;
}

/**
 * Builds the on-document label (N.k) and the prev/next popup targets for a focused difference,
 * using the numbering the store already computed. Returns null when the difference isn't a grouped
 * member in the store (All tab, not-yet-computed, or imported VerifyAPI inspections) so the caller
 * can fall back to the legacy getGroupedDifferences path.
 */
export function getGroupLabelFromStore(
  members: NumberedDifference[] | undefined,
  currentId: string,
): GroupLabelFromStore | null {
  if (!members || members.length <= 1) return null;

  const index = members.findIndex((member) => member.id === currentId);
  if (index === -1) return null;

  const current = members[index];
  if (current.subgroupIndex == null) return null;

  const length = members.length;
  return {
    labelText: `${current.groupIndex}.${current.subgroupIndex}`,
    index,
    previous: members[(index - 1 + length) % length],
    next: members[(index + 1) % length],
    representative: members[0],
  };
}
